module.exports = __webpack_public_path__ + "img/home-portfolio.24543e49.svg";